import styled from 'styled-components';
import { palette } from 'styled-theme';
import WithDirection from '@iso/lib/helpers/rtl';

const InventoryWrapper = styled.div`
width: 100%;
height: 100%;
min-height: 100%;
max-height: 100%;
display: block;
text-align: center;
margin: 0;
padding: 0;
box-sizing: border-box !important;
// new
// width: 100vw;
// height: 100vh;
// display: flex;
// flex-direction: column;
// justify-content: center;
// text-align: center;

.inventoryLoading {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  justify-content: center;

  .loadingLogo {
    margin: auto;
    @media only screen and (min-width: 767px) {
      width: 10%;
    }
    @media only screen and (max-width: 768px) {
      width: 15%;
    }

    @media only screen and (max-width: 425px) {
      width: 25%;
    }

    @media only screen and (max-width: 375px) {
      width: 30%;
    }

    @media only screen and (max-width: 320px) {
      width: 35%;
    }
  }
}
.inventoryCont {
  width: 90%;
  min-height: 100% !important;
  height: 100% !important;
  margin: 0 auto;
  padding-top: 20px !important;
  box-sizing: border-box !important;
  display: block;
  max-height: 100% !important;

  .inventoryAvatar {
    display: block;
    .inventoryImg {
      width: 250px;
      heigth: 250px;
      max-width: 250px;
      max-heigth: 250px;
    }
  }

  .inventoryBody {
    width: 70%;
    margin: 40px auto 0 auto;

    @media only screen and (max-width: 767px) {
      display: block !important; 
      .inventoryLeft {
        min-width: 100% !important;
        max-width: 100% !important;
        width: 100% !important;\
      }

      .inventoryRight {
        min-width: 100% !important;
        max-width: 100% !important;
        width: 100% !important;
      }
    }
    .inventoryLeft {
      min-width: 40%;
      max-width: 40%;
      width: 40%;

      .ant-carousel {
        .slick-dots {
          list-style: disc inside !important;
          // position: initial !important;
        }

        .slick-dots li {
          height: 8px;
          width: 8px;
        }

        .slick-dots li button {
          background: #1f2431 !important;
          height: 8px;
          border-radius: 50% !important;
        }

        .slick-dots-bottom {
          // bottom: 0 !important;
        }
      }
    }

    .inventoryRight {
      min-width: 55%;
      max-width: 55%;
      width: 55%;
      text-align: left;

      .itemTitle {
        margin: 0 !important;
      }

      .itemPrice {
        margin-top: 0 !important;
      }
    }

    .inventoryRightBottom {
      max-width: 50%;
      width: 50%;
      min-width: 50%;

      .maxQtyMessage {
        color: #f64744;
        font-size: 11px;
      }

      .wrapper-charge {
        display: flex;
        // border: 1px solid ${palette('border', 0)};
        border: 1px solid ${palette('border', 0)};
        max-width: 100% !important;

        @media only screen and (min-width: 1024px) {
          max-width: 70% !important;
        }
      }
    }

    .inventoryLeftBottom {
      max-width: 50%;
      width: 50%;
      min-width: 50%;

      .maxQtyMessage {
        color: #f64744;
        font-size: 11px;
      }

      .wrapper {
        display: flex;
        border: 1px solid ${palette('border', 0)};
        max-width: 50% !important;
        max-height: 33px;

        @media only screen and (max-width: 1024px) {
          max-width: 60% !important;
        }
  
        .plusminus {
          height: 100%;
          width: 100% !important;
          background: white;
          border: none;
          font-size: 20px;
          color: #5f5fce;
          box-shadow: none !important;
          padding: 0 !important;
          border-radius: 0 !important;
  
          &:first-child {
            border-right: 1px solid ${palette('border', 0)};
          }
          &:last-child {
            border-left: 1px solid ${palette('border', 0)};
          }
        }
        
        .ant-form-item {
          margin: 0 !important;
          .ant-form-item-control {
            min-height: 100% !important;
            height: 100% !important;
            max-height: 100% !important;
            .ant-form-item-control-input {
              min-height: 100% !important;
              height: 100% !important;
              max-height: 100% !important;
              .ant-form-item-control-input-content {
                min-height: 100% !important;
                height: 100% !important;
                max-height: 100% !important;
                .num {
                  height: 100% !important;
                  width: 100% !important;
                  min-width: 100% !important;
                  max-width: 100% !important;
                  border: none;
                  font-size: 20px;
                  &:active,
                  &:focus,
                  &:focus:active {
                    background-image: none;
                    outline: 0;
                    box-shadow: none;
                  } 
                }
              }
            }
          }
        }
      }
    }

    .ant-spin-container {
      background-color: #f7f7f9 !important;
      // padding: 20px;

      .ant-table-content {
        .ant-table-tbody {
          tr:nth-child(odd){
            background-color: #efefef;
          }
        }
      }
    }
    .detailsTitle {
      display: flex;
      box-sizing: border-box;
      flex-direction: row;
      justify-content: flex-start;
      color: ${palette('primary', 0)};
      // padding: 36px 0 20px 0;
      font-weight: 500;
    }

    .itemBody {
      padding: 10px 5px 10px 5px !important;
      box-sizing: border-box !important;
      .leftItems {
        margin: auto !important;

        .ant-typography {
          margin: auto !important;
        }
      }

      .rightItems {
        margin: auto !important;

        .ant-row {
          margin: auto !important;

          .ant-col {
            font-size: 9px !important;
            .ant-form-item-explain {
              font-size: 10px !important;
              text-align: left;
            }
          }
        }
      }
    }
    
    .nextButton {
      margin-top: 14px;
      width: 40%;
      &:disabled {
        color: #9789ce !important;
      }
    }
    .nextButtonNbi {
      margin-top: 14px;
      &:disabled {
        color: #9789ce !important;
      }
    }
    @media only screen and (max-width: 768px) {
      width: 90% !important;
    }
    @media only screen and (max-width: 425px) {
    }
    @media only screen and (max-width: 375px) {
      width: 95% !important;
    }
    @media only screen and (max-width: 320px) {
    }
  }
}
.inventoryFooter {
  width: 50%;
  padding: 10px !important;
  box-sizing: border-box !important;
  text-align: center !important;
  margin: 20px auto 0 auto;
  .footerContainer {
    width: 100% ;

    .footerText {
      text-align: left;
      font-size: 11px;
      @media only screen and (max-width: 320px) {
        font-size: 9px !important;
      }
    }
  }
  @media only screen and (max-width: 768px) {
    width: 90% !important;
  }
  @media only screen and (max-width: 425px) {
  }
  @media only screen and (max-width: 375px) {
    width: 95% !important;
  }
  @media only screen and (max-width: 320px) {
  }
}
`;

export default WithDirection(InventoryWrapper);
